export const USER_UPDATED = "USER_UPDATED";
export const USER_TYPE_UPDATED = "USER_TYPE_UPDATED";
